<mat-slider class="w-full" discrete [min]="min" [max]="max" [step]="step"
  [color]="sliderColor" (blur)="onSliderTouched()">
  <input matSliderThumb [formControl]="slider" (valueChange)="onSliderChange($event)" />
</mat-slider>
<div class="standard-range">
  <div class="standard-range-track" [style.left]="trackLeft + '%'" [style.right]="trackRight + '%'"></div>
</div>
